import {
  computed,
  Injectable,
  Signal,
  signal,
  WritableSignal,
} from "@angular/core";
import { Router } from "@angular/router";
import { Observable, switchMap, tap } from "rxjs";
import { User } from "../interfaces/user.interface";
import { AuthService } from "../modules/auth/services/auth.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  initCompleted: WritableSignal<boolean> = signal(false);
  currentUser: WritableSignal<User | null> = signal(null);
  isAuthenticated: Signal<boolean>;

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
    this.isAuthenticated = computed(() => !!this.currentUser());
  }

  init(): Promise<void> {
    return this.authService
      .loadCurrentUser()
      .then((user) => {
        this.currentUser.set(user);
      })
      .catch((err) => {
        this.currentUser.set(null);
      })
      .finally(() => {
        this.initCompleted.set(true);
      });
  }

  login(username: string, password: string): Observable<User> {
    return this.authService.login(username, password).pipe(
      switchMap(() => this.authService.fetchUserFromBackend()),
      tap((user) => {
        this.currentUser.set(user);
      }),
    );
  }

  logout(): Observable<void> {
    return this.authService.logout().pipe(
      tap(() => {
        this.currentUser.set(null);
      }),
    );
  }
}
